import type { FormEvent } from "react";
import { getStrings } from "../i18n/strings";

type Strings = ReturnType<typeof getStrings>;

// The second thing the hero offers — checking someone else's address — directly above the visitor's
// own result card and still inside the dark hero (spec §十五). Full card width, not the old 420px
// "little utility box": the reference design gives this the same measure as the card below it, so
// the two read as one dashboard rather than as a result plus a stray widget. The `--compact`
// modifier that carried that old semantic is gone; `.home-ip-lookup` is what the width lives on now.
//
// Everything functional is unchanged: the same <form id="ip-check"> other pages' CMS content and
// "Related tools" blocks already link to, the same input, the same submit handler, the same
// loading state.
export function HomeIpSearch({
  strings,
  value,
  onChange,
  onSubmit,
  checking,
  error,
}: {
  strings: Strings;
  value: string;
  onChange: (value: string) => void;
  onSubmit: (event: FormEvent) => void;
  checking: boolean;
  // Client-side syntax check only (see HomePage.tsx) — never a replacement for the backend's own
  // validation, which still runs on submit regardless of what this prop says.
  error?: string | null;
}) {
  return (
    <form className="home-search home-ip-lookup" id="ip-check" onSubmit={onSubmit}>
      <label className="home-search__label" htmlFor="home-ip-search-input">{strings.checkAnother}</label>
      <div className="home-search__field">
        <input
          id="home-ip-search-input"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={strings.ipPlaceholder}
          aria-label={strings.ipPlaceholder}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? "home-ip-search-error" : undefined}
          inputMode="text"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
        />
        <button type="submit" className="btn btn-primary" disabled={checking || Boolean(error)}>
          {checking && <span className="spinner" aria-hidden="true" />}
          {checking ? strings.loading : strings.checkButton}
        </button>
      </div>
      {error && (
        <p id="home-ip-search-error" className="home-search__error" role="alert">
          {error}
        </p>
      )}
    </form>
  );
}
